module.exports = __webpack_public_path__ + "805f44aacc93c222f53fdea84d5dbd0a.jpg";